import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { CheckCircle2, Heart, ShieldPlus, Sparkles } from 'lucide-react';
import { useScreenInit } from '../useScreenInit';
export function AboutPage() {
  useScreenInit();
  const amenities = ['Same Day Dental Crowns', 'State-of-the-Art Intraoral Cameras', 'Digital X-Rays and Panoramic', 'Laser Soft Tissue Reshaping and Therapy', 'Relaxing Reception Area with Flat-Screen TV', 'Visitor WIFI Access', 'Private Consultation Room', 'Private Treatment Rooms', 'Nitrous Oxide “Comfort Gas”', 'On-Call System for Helping with After-Hours Urgent Needs', 'Wheelchair Access'];
  const images = ['https://cdn.magicpatterns.com/uploads/gFa6sSQRNNrgiza8irxCS2/Screenshot_2026-06-22_192032.png', 'https://cdn.magicpatterns.com/uploads/bkxAS7mUJeJ6qo9pQJqMbz/Screenshot_2026-06-22_192105.png', 'https://cdn.magicpatterns.com/uploads/o2Qma35yGocTpCsb6C45j6/Screenshot_2026-06-22_192126.png', 'https://cdn.magicpatterns.com/uploads/nHKNAV5X6VoW4KUZim48GY/Screenshot_2026-06-22_192158.png', 'https://cdn.magicpatterns.com/uploads/nQfVCbfduBucKg1x4KybCX/Screenshot_2026-06-22_192232.png'];
  return <div className="min-h-screen bg-white" data-id="element-328">
      <Header data-id="element-329" />

      <main className="pt-40 pb-24" data-id="element-330">
        <div className="max-w-7xl mx-auto px-4" data-id="element-331">
          {/* Our Dental Office Section */}
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-24" data-id="element-332">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} data-id="element-333">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#cef4d2]/50 text-[#54c595] font-bold text-sm mb-6" data-id="element-334">
                <Heart size={16} data-id="element-335" />
                Patient-First Care
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-[#225274] mb-6 leading-tight" data-id="element-336">
                Our Dental Office
              </h1>
              <div className="space-y-6 text-lg text-slate-600 leading-relaxed" data-id="element-337">
                <p data-id="element-338">
                  From the moment you visit our office, you’ll see that this is
                  a truly special place where our patients are our top priority.
                  We take pride in providing high-quality, pain-free, and
                  personalized dental care.
                </p>
                <p data-id="element-339">
                  Our team is dedicated to helping every patient achieve and
                  maintain optimal oral health while enjoying the confidence of
                  a natural, beautiful smile. With state-of-the-art technology
                  and a conservative treatment approach, our office is the
                  perfect dental home for you and your family.
                </p>
              </div>
            </motion.div>

            {/* Image Grid */}
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} className="grid grid-cols-2 gap-4" data-id="element-340">
              <div className="space-y-4" data-id="element-341">
                <img src={images[0]} alt="Patient smiling" className="rounded-2xl w-full h-64 object-cover shadow-lg" data-id="element-342" />
                <img src={images[1]} alt="Dental procedure" className="rounded-2xl w-full h-48 object-cover shadow-lg" data-id="element-343" />
              </div>
              <div className="space-y-4 mt-8" data-id="element-344">
                <img src={images[2]} alt="Dentist and patient" className="rounded-2xl w-full h-48 object-cover shadow-lg" data-id="element-345" />
                <img src={images[3]} alt="Happy patient" className="rounded-2xl w-full h-64 object-cover shadow-lg" data-id="element-346" />
              </div>
            </motion.div>
          </div>

          {/* Technology & Amenities Section */}
          <div className="bg-[#225274] rounded-3xl p-10 md:p-16 text-white relative overflow-hidden shadow-2xl" data-id="element-347">
            <div className="absolute top-0 right-0 w-96 h-96 bg-[#4bafbc]/20 rounded-full blur-3xl -mr-20 -mt-20" data-id="element-348" />
            <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#54c595]/20 rounded-full blur-3xl -ml-20 -mb-20" data-id="element-349" />

            <div className="relative z-10" data-id="element-350">
              <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-351">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 rounded-full mb-6 backdrop-blur-sm" data-id="element-352">
                  <Sparkles className="text-[#54c595]" size={32} data-id="element-353" />
                </div>
                <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-354">
                  Technology & Amenities
                </h2>
                <p className="text-lg text-white/80" data-id="element-355">
                  Your comfort is our number one priority. We take pride in the
                  comforts we provide to allow you to have an exceptional dental
                  experience.
                </p>
              </div>

              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-356">
                {amenities.map((amenity, idx) => <motion.div key={idx} initial={{
                opacity: 0,
                y: 10
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: idx * 0.05
              }} className="flex items-start gap-4 bg-white/5 p-6 rounded-xl border border-white/10 hover:bg-white/10 transition-colors backdrop-blur-sm" data-id="element-357">
                    <CheckCircle2 className="text-[#54c595] flex-shrink-0 mt-1" size={24} data-id="element-358" />
                    <span className="font-medium text-white/90" data-id="element-359">{amenity}</span>
                  </motion.div>)}
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-360" />
    </div>;
}